const fontWeights = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 300,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
}

const sizes = {
  fontWeights,
}

export default sizes
